<template>
  <router-link
    v-if="hasId"
    class="gs-ent-link"
    :to="to"
  >{{ displayName }}</router-link>
  <GsVal v-else :value="displayName" />
</template>

<script>
import { P } from '@/router/paths'
import GsVal from '@/components/GsVal/index.vue'

export default {
  name: 'EnterpriseLink',
  components: { GsVal },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    hasId() {
      const id = this.id
      return id != null && String(id).trim() !== '' && String(id) !== '0'
    },
    displayName() {
      const name = this.name == null ? '' : String(this.name).trim()
      if (name && name !== 'null' && name !== 'undefined') return name
      return this.hasId ? '查看所属企业' : ''
    },
    to() {
      return P.enterprise(this.id)
    }
  }
}
</script>

<style scoped>
.gs-ent-link {
  color: #0165FF;
  text-decoration: none;
  cursor: pointer;
  font: inherit;
  border-bottom: 1px solid transparent;
}
.gs-ent-link:hover {
  border-bottom-color: #0165FF;
}
</style>
